import React from 'react';
import styles from './styles/Detail.module.css';
import Header from '../Components/Header';
import iphone from '../imgs/iphone.png';

export default class Store extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      json: null
    }
  }

  componentDidMount() {
    fetch("assets/store.json")
      .then(res => res.json())
      .then(json => this.setState({ json }))
  }

  render() {
    const { json } = this.state;
    return (
      <div className={styles.bg}>
        <Header />
        <div className={styles.area}>
          <div className={styles.iphone}>
            <img src={iphone} className={styles.img} />
            <div className={styles.screen}>
              <div className={styles.title}>
                大豪云商城
              </div>
              <div className={styles.version}>
                {json && json.version}
              </div>
              <div className={styles.btns}>
                <a href="javascript:;">
                  <div className={styles.btn}>APP下载</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}